const CustomerScreenQuestionType = {
    BOOLEAN: 'BOOLEAN',
    OPTIONS: 'OPTIONS'
};

/* istanbul ignore next */
if (typeof module !== 'undefined' && module.exports) {
    module.exports = CustomerScreenQuestionType;
}
